import {ReactElement} from 'react';
import {Link} from '@shopify/hydrogen';
import {NewsArticleListItemType} from '../../types/backend';
import {formatPublishedAtDate, getNewsArticleCategoryLabel} from '../../utils';
import {NewsArticlePlaceholderDesktopPNG} from '../../assets/img';
import ImageContainer from '../ImageContainer.client';

interface NewsPreviewTileProps {
  article: NewsArticleListItemType;
}

export default function NewsPreviewTile({
  article,
}: NewsPreviewTileProps): ReactElement {
  const {
    featured_image_desktop_webp,
    featured_image_desktop_jpeg,
    title,
    category,
    published_at,
    slug,
    summary,
    label,
  } = article;
  return (
    <div className="list-type-2__item" key={article.uuid}>
      <Link to={`/news/${article.slug}`} className="list-type-2__image">
        <ImageContainer
          jpegSrc={
            featured_image_desktop_jpeg || NewsArticlePlaceholderDesktopPNG
          }
          webpSrc={featured_image_desktop_webp}
          widthInPx={800}
          heightInPx={800}
          alt={title}
        />
      </Link>
      <div key={label} className="tag-element">
        {label}
      </div>
      <div className="list-type-2__meta">
        <div className="list-type-2__date date-element separator-r">
          {formatPublishedAtDate(published_at)}
        </div>
        <Link
          to={`/news?category=${category}`}
          className="meta-link list-type-2__category"
        >
          {getNewsArticleCategoryLabel(category)}
        </Link>
      </div>
      <h4 className="list-type-2__title title-item" title={title}>
        <Link to={`/news/${slug}`}>{title}</Link>
      </h4>
      <div className="text-content">{summary}</div>
    </div>
  );
}
